import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var DeleteRowIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69404 9.15937C5.17778 9.15937 4.7573 9.57985 4.7573 10.0961V43.056C4.7573 43.5722 5.17778 43.9927 5.69404 43.9927H38.5736C39.0899 43.9927 39.5103 43.5722 39.5103 43.056V24.1338C39.5103 23.5795 39.9597 23.1302 40.514 23.1302C41.0683 23.1302 41.5176 23.5795 41.5176 24.1338V43.056C41.5176 44.6808 40.1985 46 38.5736 46H5.69404C4.06918 46 2.75 44.6808 2.75 43.056V10.0961C2.75 8.47125 4.06918 7.15207 5.69404 7.15207H23.0371C23.5914 7.15207 24.0408 7.60142 24.0408 8.15572C24.0408 8.71002 23.5914 9.15937 23.0371 9.15937H5.69404Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76338 17.3625C2.76338 16.8082 3.21273 16.3589 3.76703 16.3589H23.4653C24.0196 16.3589 24.469 16.8082 24.469 17.3625C24.469 17.9168 24.0196 18.3662 23.4653 18.3662H4.77068V25.5657H40.514C41.0683 25.5657 41.5176 26.015 41.5176 26.5693C41.5176 27.1236 41.0683 27.573 40.514 27.573H3.76703C3.21273 27.573 2.76338 27.1236 2.76338 26.5693V17.3625Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M40.514 26.5693H3.76703V35.7762H40.514V26.5693Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76338 26.5693C2.76338 26.015 3.21273 25.5657 3.76703 25.5657H40.514C41.0683 25.5657 41.5176 26.015 41.5176 26.5693V35.7762C41.5176 36.3305 41.0683 36.7798 40.514 36.7798H3.76703C3.21273 36.7798 2.76338 36.3305 2.76338 35.7762V26.5693ZM4.77068 27.573V34.7725H39.5103V27.573H4.77068Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6867 4.0073C33.067 4.0073 30.1296 6.94737 30.1296 10.5779C30.1296 14.2084 33.067 17.1484 36.6867 17.1484C40.3065 17.1484 43.2439 14.2084 43.2439 10.5779C43.2439 6.94737 40.3065 4.0073 36.6867 4.0073ZM28.1223 10.5779C28.1223 5.84211 31.955 2 36.6867 2C41.4184 2 45.2512 5.84211 45.2512 10.5779C45.2512 15.3136 41.4184 19.1557 36.6867 19.1557C31.955 19.1557 28.1223 15.3136 28.1223 10.5779Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3911 10.5779C32.3911 10.0236 32.8405 9.57421 33.3948 9.57421H39.9787C40.533 9.57421 40.9824 10.0236 40.9824 10.5779C40.9824 11.1322 40.533 11.5815 39.9787 11.5815H33.3948C32.8405 11.5815 32.3911 11.1322 32.3911 10.5779Z"
  }));
});
DeleteRowIcon.displayName = 'DeleteRowIcon';
DeleteRowIcon.defaultProps = {
  'aria-label': 'DeleteRow'
};
export default DeleteRowIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/DeleteRowIcon/index.js
// module id = 1828
// module chunks = 12